import { render, staticRenderFns } from "./device-info-card.vue?vue&type=template&id=1006c12f&scoped=true"
import script from "./device-info-card.vue?vue&type=script&lang=js"
export * from "./device-info-card.vue?vue&type=script&lang=js"
import style0 from "./device-info-card.vue?vue&type=style&index=0&id=1006c12f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1006c12f",
  null
  
)

export default component.exports